<template>
    <div class="custom-settings-popover column-settings-wrapper">
        <div class="column-settings">
            <v-bar wrapper="v-bar-col-settings">
                <div class="subtitle">
                    выводить данные:
                </div>
                <el-form>
                    <el-checkbox-group class="dialog-checkbox-group" v-model="columns">
                        <el-checkbox
                            :class="['dialog-checkbox', { hide: column.colId === '0' }]"
                            size="medium"
                            name="columns"
                            v-for="column in columnsModel"
                            :label="column.colId"
                            :key="column.colId"
                        >
                            {{ column.name | uppercase }}
                        </el-checkbox>
                    </el-checkbox-group>
                    <div class="actions-wrapper">
                        <div class="btn btn-default grey" @click="hideColumnSettings">
                            отменить
                        </div>
                        <div class="btn btn-default orange" @click="setSelectedColumns(columnsModel)">
                            применить
                        </div>
                    </div>
                </el-form>
            </v-bar>
        </div>
    </div>
</template>

<script>
import { eventBus } from '@/common/eventBus';
import VBar from 'v-bar';

export default {
    name: 'ColumnSettingsMobile',
    data() {
        return {
            columns: []
        };
    },
    components: { VBar },
    props: {
        attributes: {
            type: Object,
            default: () => {}
        },
        columnsModel: {
            type: Array,
            default: () => {}
        }
    },
    methods: {
        hideColumnSettings() {
            eventBus.$emit('hideColumnSettings');
        },
        //имена чекбоксов
        setColNames(columnSettings) {
            columnSettings.forEach((item) => {
                const colName = item.colId;
                if (Object.prototype.hasOwnProperty.call(this.attributes, colName)) {
                    this.$set(item, 'name', this.attributes[colName].name);
                }
            });
        },
        //активные(видимые) столбцы иниц.
        getActiveColumns(columnSettings) {
            columnSettings.forEach((item) => {
                const colName = item.colId;
                if (Object.prototype.hasOwnProperty.call(this.attributes, colName) && !this.attributes[colName].hide) {
                    this.columns.push(colName);
                }
            });
        },
        //фиксируем выбранные/невыбранные столбцы(клик по кнопке применить)
        setSelectedColumns(settings) {
            settings.forEach((item) => {
                if (this.columns.includes(item.colId)) {
                    item.hide = false;
                } else {
                    if (item.hide === false) {
                        item.hide = true;
                    }
                }
                //иконка настроек для десктоп
                if (item.colId === '0') {
                    item.hide = false;
                }
                this.$delete(item, 'name');
            });
            eventBus.$emit('newColumnSettings', this.columnsModel);
            this.hideColumnSettings();
        }
    },
    mounted() {
        this.setColNames(this.columnsModel);
        this.getActiveColumns(this.columnsModel);
    },
    filters: {
        uppercase: function(value) {
            if (!value) return '';
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    }
};
</script>
